import { render, staticRenderFns } from "./SalesViewChart.vue?vue&type=template&id=724313bc&scoped=true&"
import script from "./SalesViewChart.vue?vue&type=script&lang=js&"
export * from "./SalesViewChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesViewChart.vue?vue&type=style&index=0&id=724313bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724313bc",
  null
  
)

export default component.exports